import { createContext, useContext } from 'react';

export const WizardContext = createContext()

const useWizardContext = () => {
  const context = useContext(WizardContext)
  if (!context) {
    throw new Error('The composite component cannot be rendered outside of the parent Wizard.')
  }

  return context
}

export default useWizardContext